// @flow

import React, { useMemo } from 'react';
import CategorizedFilterBar from '../pills/categorized-filter-bar';
import type { Filter } from '../pills/categorized-filter-bar';
import type { Option } from '../pills/categorized-picker-popover';
import { findTagTypeMeta } from './tag-types';
import type { TagTypeMeta } from './tag-types';

type Props = {
  tagTypes: TagTypeMeta[],
  allTags: $ReadOnlyArray<Object>,
  activeFilters: $ReadOnlyArray<Object>,
  onAdd: (tag: Object) => mixed,
  onRemove: (tag: Object) => mixed,
  onClear: () => mixed,
};

const TagFilterBar = ({
  tagTypes,
  allTags,
  activeFilters,
  onAdd,
  onRemove,
  onClear,
}: Props) => {
  const categories = useMemo(
    () => tagTypes.map((tt) => ({ key: tt.key, label: tt.label, color: tt.color })),
    [tagTypes],
  );

  const options = useMemo(
    () =>
      allTags.map((t) => ({
        id: t.id,
        label: t.tagValue,
        categoryKey: t.tagType,
      })),
    [allTags],
  );

  const filters = useMemo(
    () =>
      activeFilters.map((f) => {
        const meta = findTagTypeMeta(tagTypes, f.tagType);
        return {
          id: f.id,
          categoryKey: f.tagType,
          valueLabel: f.tagValue,
          color: meta.color,
        };
      }),
    [activeFilters, tagTypes],
  );

  const handleAdd = (opt: Option) => {
    const tag = allTags.find((t) => t.id === opt.id);
    if (tag) onAdd(tag);
  };
  const handleRemove = (filter: Filter) => {
    const tag = activeFilters.find((f) => f.id === filter.id);
    if (tag) onRemove(tag);
  };

  return (
    <CategorizedFilterBar
      label="Tags:"
      categories={categories}
      options={options}
      activeFilters={filters}
      onAdd={handleAdd}
      onRemove={handleRemove}
      onClear={onClear}
      categoryHeaderLabel="Filter by tag type"
    />
  );
};

export default TagFilterBar;
